/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Section_InternalInputs */

const en_section_internal = /** @type {(inputs: Section_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal`)
};

const es_section_internal = /** @type {(inputs: Section_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interno`)
};

/**
* | output |
* | --- |
* | "Internal" |
*
* @param {Section_InternalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const section_internal = /** @type {((inputs?: Section_InternalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Section_InternalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_section_internal(inputs)
	return es_section_internal(inputs)
});